module.exports = __webpack_public_path__ + "img/IB.2115282a.svg";